import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useEntitiesById } from "@hooks/useEntities";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";

export const EntityCell = memo(function EntityCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, number>) {
    const entitiesById = useEntitiesById();
    const entity = entitiesById.get(row.original.entityId);

    if (!entity) {
        return <ViewTableCell>-</ViewTableCell>;
    }

    return (
        <ViewTableCell>
            <AvatarTooltip content={entity.name}>
                <EntityAvatar size="xs" entity={entity} copyId={entity.id} />
            </AvatarTooltip>
        </ViewTableCell>
    );
});
